const styles = (theme) => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 60,
    height: 'calc(100% - 60px)',
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64,
  },
})

export default styles
